<template>
  <div class="equipamentoDialog">
    <md-dialog
      md-open-from="#addEquipamento"
      md-close-to="#addEquipamento"
      ref="eq_dialog"
    >
      <div
        v-if="isLoading"
        style="display:contents"
      >
        <md-dialog-content>
          <md-layout
            md-align="center"
            md-column
            md-gutter
          >
            <span class="md-headline">SALVANDO</span>
            <md-spinner
              :md-size="50"
              :md-stroke="1"
              md-indeterminate
            ></md-spinner>
          </md-layout>
        </md-dialog-content>
      </div>
      <div
        v-else
        style="display:contents"
      >
        <md-dialog-title>Equipamento</md-dialog-title>
        <md-dialog-content>
          <md-input-container>
            <label>Tipo do item</label>
            <md-select v-model="structure">
              <md-option
                v-for="(eq, index) in equipmentList"
                :value="index"
                :key="eq.name"
              >{{ eq.name }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container>
            <label>Informações adicionais</label>
            <md-textarea
              v-model="description"
              maxlength="120"
            ></md-textarea>
          </md-input-container>
          <md-input-container>
            <label>Marca</label>
            <md-input
              v-model="brand"
              maxlength="100"
            ></md-input>
          </md-input-container>
          <md-input-container>
            <label>Modelo</label>
            <md-input
              v-model="model"
              maxlength="100"
            ></md-input>
          </md-input-container>
          <md-input-container>
            <label>Patrimônio</label>
            <md-input
              v-model="patrimony"
              maxlength="120"
            ></md-input>
          </md-input-container>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="close()"
          >Cancelar</md-button>
          <md-button
            class="md-primary"
            v-show="currentItemKey != null"
            @click="removeItem()"
          >Excluir</md-button>
          <md-button
            class="md-primary"
            v-show="currentItemKey != null"
            @click="saveItem()"
          >Alterar</md-button>
          <md-button
            class="md-primary"
            v-show="currentItemKey == null"
            @click="addItem()"
          >Adicionar</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'addStructureDialog',
  computed: {
    ...mapState({
      equipmentList: (state) => state.equipmentList
    })
  },
  data: () => ({
    currentArea: 0,
    structure: -1,
    currentItemKey: null,
    id: '',
    name: '',
    type: null,
    description: '',
    patrimony: '',
    model: '',
    brand: '',
    x: 0,
    y: 0,
    photos: [],
    isLoading: false
  }),
  props: ['activeProcess'],
  beforeMount () {
    this.FETCH_EQUIPMENT_LIST()
  },
  methods: {
    ...mapActions([
      'FETCH_EQUIPMENT_LIST',
      'CREATE_STRUCTURE',
      'SET_STRUCTURE',
      'REMOVE_STRUCTURE'
    ]),
    openDialog (_areaKey, _item, _key) {
      if (_item) {
        this.name = _item.name
        this.type = _item.type
        this.id = _item.id
        this.description = _item.description
        this.patrimony = _item.patrimony
        this.model = _item.model
        this.brand = _item.brand
        this.x = _item.x
        this.y = _item.y
        this.photos = _item.photos
        if (_item.type === 'equipment') {
          this.structure = _item.structureId
        } else {
          this.structure = _item.type
        }
        this.currentItemKey = _key
      } else {
        this.reset()
      }
      this.currentArea = _areaKey
      this.$refs.eq_dialog.open()
    },
    close () {
      this.$refs.eq_dialog.close()
    },
    reset () {
      this.currentItemKey = null
      this.structure = -1
      this.id = ''
      this.name = ''
      this.type = null
      this.description = ''
      this.patrimony = ''
      this.model = ''
      this.brand = ''
      this.x = 0
      this.y = 0
      this.photos = []
    },
    removeItem () {
      this.isLoading = true
      this.REMOVE_STRUCTURE({
        areaKey: this.currentArea,
        key: this.currentItemKey
      }).then(() => {
        this.isLoading = false
        this.close()
      })
    },
    saveItem () {
      this.isLoading = true
      var newItem = {
        structureId: null,
        id: this.id,
        name: '',
        type: null,
        description: this.description,
        x: this.x,
        y: this.y,
        patrimony: this.patrimony,
        model: this.model,
        brand: this.brand,
        photos: []
      }

      if (this.structure !== 'hydraulic' && this.structure !== 'eletric') {
        newItem.structureId = this.structure
        newItem.type = 'equipment'
        newItem.name = this.equipmentList[this.structure].name
        newItem.patrimony = this.patrimony
        newItem.model = this.model
        newItem.brand = this.brand
        this.equipmentList[this.structure].photos.forEach((photo) => {
          newItem.photos.push(Object.assign({}, photo))
        })
      } else {
        newItem.type = this.structure
        newItem.name = ''
        newItem.type === 'hydraulic' ? 'Ponto Hidráulico' : 'Ponto Elétrico'
        newItem.photos = [{ description: 'total' }]
      }
      // console.log('salvando...')
      // console.log(newItem, this.currentArea, this.currentItemKey)
      this.SET_STRUCTURE({
        structure: newItem,
        areaKey: this.currentArea,
        structureKey: this.currentItemKey
      }).then(() => {
        this.isLoading = false
        this.close()
      })
    },
    addItem () {
      this.isLoading = true
      var newItem = {
        structureId: null,
        id: '',
        name: '',
        patrimony: '',
        model: '',
        brand: '',
        type: null,
        description: this.description,
        x: this.x,
        y: this.y,
        photos: []
      }
      if (this.structure < 0) {
        console.log('STRUTURA UNDEFINED:' + this.structure)
        this.isLoading = false
        this.close()
        return
      }

      if (this.structure !== 'hydraulic' && this.structure !== 'eletric') {
        newItem.structureId = this.structure
        newItem.type = 'equipment'
        newItem.patrimony = this.patrimony
        newItem.model = this.model
        newItem.brand = this.brand
        newItem.name = this.equipmentList[this.structure].name
        this.equipmentList[this.structure].photos.forEach((photo) => {
          newItem.photos.push(Object.assign({}, photo))
        })
      } else {
        newItem.type = this.structure
        newItem.name =
          newItem.type === 'hydraulic' ? 'Ponto Hidráulico' : 'Ponto Elétrico'
        newItem.photos = [{ description: 'total' }]
      }

      this.CREATE_STRUCTURE({
        structure: newItem,
        areaKey: this.currentArea
      }).then(() => {
        this.isLoading = false
        this.close()
      })
    }
  }
}
</script>
<style>
.md-list-item-container > span {
  white-space: normal !important;
  overflow: auto;
  text-overflow: unset;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// AddStructureDialog.vue?1ae79148